import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { semanticColors } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  firstRow: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '16px'
  },
  row: {
    marginTop: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  },
  linkNameInput: {
    width: '70%',
    '& .MuiInputBase-root.MuiOutlinedInput-root': { margin: 0 }
  },
  linkURLInput: {
    width: '100%',
    '& .MuiInputBase-root.MuiOutlinedInput-root': { margin: 0 }
  },
  deleteButton: {
    marginTop: '0px',
    color: semanticColors.foreground.errorLarge,
    flexShrink: 0
  }
});
